import classnames from 'classnames/bind'
import { useTranslation } from 'next-i18next'

// Components
import Icon from '@/assets/icons'

// Styles
import styles from './style.module.scss'

const cx = classnames.bind(styles)

const TypeEmpty = () => {
  const { t } = useTranslation()

  return (
    <div className={cx('empty')}>
      <div className={cx('empty__image')}>
        <Icon.TypeEmpty />
      </div>
      <p className={cx('empty__title')}>
        {t('Type_Empty_Title_1')}
        <br /> {t('Type_Empty_Title_2')}
      </p>
      <p className={cx('empty__description')}>{t('Type_Empty_Description')}</p>
    </div>
  )
}

export default TypeEmpty
